export const typeMapWithIds = (type, ids) => (
  {
    actor: {
      actor_ids: ids
    },
    malware: {
      malware_ids: ids
    },
    campaign: {
      campaign_ids: ids
    }
  }[type]
)
